import { takeLatest, call, put } from 'redux-saga/effects';
import {  initProductMeta } from '@utils/helper';
import {
  getProductSuccess,
  getProductFailure,
  postProductSuccess,
  postProductFailure,
  getCategorySuccess,
  getCategoryFailure,
  onSelectProductAction,
} from './actions';
import { GET_PRODUCT_REQUEST, POST_PRODUCT_REQUEST, GET_CATEGORY_REQUEST } from './constants';
import { getProductApi, postProductApi, getCategoryApi } from './api';

export function* getProductSaga() {
  try {
    const res = yield call(getProductApi);
    const productList = initProductMeta(res.data);
    yield put(getProductSuccess(productList));
  } catch (error) {
    yield put(getProductFailure(error));
  }
}

//old version
// export function* getProductSaga() {
//   try {
//     const res = yield all([
//       call(getProductApi),
//       // call(getProductQuantityApi)
//     ]);
//     // const productQuantityList = res[1].data;
//     const productList = res[0].data;
//     const data = [];
//     productList.forEach(pm => {
//       const {inventory} = pm;
//       let productInventory = [];
//       if(inventory){
//         productInventory = JSON.parse(inventory);
//       }
//       // const productQuantities = productQuantityList.filter(x => x.groupId === pm.pId);
//       const initBranch = {};
//       FULL_SIZE_COLUMN.forEach(size => {
//         initBranch[`${size}`] = 0;
//         PLACE_LIST.forEach(branch => {
//           initBranch[`branch${branch.value}${size}`] = 0;
//         })
//       });
//       const result = {
//         ...pm,
//          uid(),
//         ...initBranch,
//       }

//       // const customProductSize = productQuantities.filter(x => !FULL_SIZE.includes(`size${x.size}`));
//       // const customResult = {};
//       // customProductSize.forEach(x => {
//       //   if (!customResult[x.size]) {
//       //     customResult[x.size] = {
//       //       ...pm,
//       //       pName: x.name,
//       //       uid: uid(),
//       //       ...initBranch,
//       //     }
//       //   }
//       //   customResult[x.size][`sizeM`] += x.available > 0 ? x.available : 0;
//       //   customResult[x.size][`branch${x.branchId}sizeM`] = x.available;
//       // })
//       // Object.keys(customResult).forEach(key => {
//       //   data.push({
//       //     ...customResult[key],
//       //   })
//       // })
//       // const fullSizeProduct = productQuantities.filter(x => FULL_SIZE.includes(`size${x.size}`));
//       // fullSizeProduct.forEach(pq => {
//       //   const { branchId } = pq;
//       //   let size = pq.size;
//       //   if (size === 'X') size = 'XL';
//       //   else if (size === 'XX') size = 'XXL';
//       //   result[`size${size}`] += pq.available > 0 ? pq.available : 0;
//       //   result[`branch${branchId}size${size}`] = pq.available;
//       // });
//       // if (fullSizeProduct.length) {
//       //   data.push(result);
//       // }
//       productInventory.forEach(pi => {
//         const {id, ...sizes} = pi;
//         Object.keys(sizes).forEach(k => {
//           let size = k;
//           if (size === 'sizeX') size = 'sizeXL';
//           else if (size === 'sizeXX') size = 'sizeXXL';
//           result[size] += sizes[k];
//           result[`branch${id}${size}`] = sizes[k];
//         });
//       })
//       data.push(result);

//     })
//     yield put(getProductSuccess(data));
//   } catch (error) {
//     yield put(getProductFailure(error));
//   }
// }
export function* postProductSaga(action) {
  try {
    const res = yield call(postProductApi, action.payload);
    yield put(postProductSuccess(res.data));
    yield put(onSelectProductAction({}));
  } catch (error) {
    yield put(postProductFailure(error));
  }
}

export function* getCategoryListSaga() {
  try {
    const res = yield call(getCategoryApi);
    yield put(getCategorySuccess(res.data));
  } catch (error) {
    yield put(getCategoryFailure(error));
  }
}

export default function* boardSaga() {
  yield takeLatest(GET_PRODUCT_REQUEST, getProductSaga);
  yield takeLatest(POST_PRODUCT_REQUEST, postProductSaga);
  yield takeLatest(GET_CATEGORY_REQUEST, getCategoryListSaga);
}

